import script from "./xueshenghuamingce.vue?vue&type=script&setup=true&lang=js"
export * from "./xueshenghuamingce.vue?vue&type=script&setup=true&lang=js"

import "./xueshenghuamingce.vue?vue&type=style&index=0&id=12c410f9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c410f9"]])

export default __exports__